import { ArfMessageModel } from "../../../model/chats/ArfMessageModel";
import { ConversationList } from "../../../model/chats/ChatListModel";
import { Message } from "../../../model/chats/GroupConversationMessageModel";
import { ReplyMessageDetailModel } from "../../../model/chats/ReplyMessageDetailModel";
import { ParticipantDetails } from "../../../model/chats/TeamConversationDetailsModel";
import { TeamMessage } from "../../../model/chats/TeamConversationMessageModel";

export type ChatsContentType = {
  type: number;
  chats: Array<ConversationList> | null;
  chatSelected?: ConversationList | null;
  browserWidth?: number;
  loadingMesages?: boolean;
};

export type ChatsListItemType = {
  type: number;
  chat: ConversationList;
  chatSelected: ConversationList | null;
  handleClick: (detail: ConversationList) => void;
};

export type ConversationsType = {
  flag: string;
  userId: string;
  participantDetail?: ParticipantDetails | null;
  messages: Record<string, TeamMessage[] | Message[]> | null;
  handleClickMessage: (message: any) => void;
  handlePressStart: (message: any) => void;
  handlePressEnd: () => void;
  selectedMesasgeIds: Array<string>;
  longPressStatus: boolean;
};

export type ConversationsMessage = {
  flag: string;
  userId: string;
  isUser: boolean;
  messageDetail: TeamMessage | Message;
  participantDetail?: ParticipantDetails | null;
  deleteLabel: string;
  longPressStatus: boolean;
};

export type ConversationsBubbleType = {
  messageType: string;
  message: string;
  autoReplayStatus?: boolean;
  deleteLabel?: string;
  formType?: string;
  arfData?: ArfMessageModel;
  imageSize?: string;
  audioRangeWidth?: string;
  videoSize?: string;
  showDocDate?: string;
  linkIsMedia?: boolean;
  audioShowControl?: boolean;
  fromMedia?: boolean;
  longPressStatus?: boolean;
};

export type ConversationsReplyType = {
  detail: ReplyMessageDetailModel | null;
};

export type ConversationsTimeType = {
  isUser: boolean;
  flag: string;
  deliveredStatus: string;
  readStatus: string;
  createDate: Date;
};

export type UpdateBlockStatusParams = {
  blockStatusVal?: string;
  participantBlockStatusVal?: string;
  participantBlockStatus: boolean;
  accountIdVal: string;
  profileId: string;
};

export type UpdateConversationSettingsParams = {
  convId: string;
  eventName: string;
  exitFlag?: string;
  muteStatus?: string;
  muteDuration?: string;
  muteType?: string;
  profileId?: string;
  blockStatus?: string;
};

export type MuteSettingsType = {
  muteStatus: string;
  muteDuration: string;
  muteType: string;
  muteEnd: string;
};

export enum ChatTextType {
  text = "text",
  url = "url",
  urlWithText = "urlWithText",
}
